export const BREAKPOINTS = {
  collaborationInit: true,
  collaborationReconnect: true,
  collaborationLocalSync: true,
  collaborationRemoteSync: true,
  collaborationShutdown: true,
  collaborationAwarenessUserSync: true,
  collaborationAwarenessFocusSync: true,
  collaborationErrors: true,
  collaborationOnSagaTake: true,
  // these to see what is sent in the wire on changes
  collaborationLocalSyncDiff: true,
  collaborationRemoteSyncDiff: true,
};

let breakpoints_backup = {...BREAKPOINTS};

export const allBreakpointsDisabled = () => {
  for (const key in BREAKPOINTS) {
    if (BREAKPOINTS[key]) return false;
  }
  return true;
};

// put pauseBreakpoints() at the beginning
export const pauseBreakpoints = () => {
  if (!allBreakpointsDisabled()) {
    Object.assign(breakpoints_backup, BREAKPOINTS);
  }
  for (const key in BREAKPOINTS) {
    BREAKPOINTS[key] = false;
  }
};
pauseBreakpoints();

// put unpauseBreakpoints() where you want to start debugging
export const unpauseBreakpoints = () => {
  if (allBreakpointsDisabled()) {
    Object.assign(BREAKPOINTS, breakpoints_backup);
  }
};

export const debugBreakpoint = (feature) => {
  // do nothing checked in
  // todo: add preactjs/babel-plugin-transform-replace-expressions
  // and replace the above with something during dev.
  // because it's breaking inside here instead
  // of at the call site.
  if (feature) {
    // debugger;
  }
};
// this didn't work for me
// //# sourceURL=inline-debug-function
